import { render, staticRenderFns } from "./IbxPreviewAsmtModal.vue?vue&type=template&id=164ff7a0"
import script from "./IbxPreviewAsmtModal.vue?vue&type=script&lang=js"
export * from "./IbxPreviewAsmtModal.vue?vue&type=script&lang=js"
import style0 from "./IbxPreviewAsmtModal.vue?vue&type=style&index=0&id=164ff7a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports